module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/empty-pic@3x-86c44b3d900009bb58749fabe418c787.png";